import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import './css/NextButton.css';

const NextButton = ({ 
  nextPath, 
  disabled = false, 
  text = "Next", 
  onClick = null,
  className = "" 
}) => {
  const navigate = useNavigate();
  const { sessionId } = useParams();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (nextPath) {
      const fullPath = sessionId ? `/app/session/${sessionId}${nextPath}` : nextPath;
      navigate(fullPath);
    }
  };

  return (
    <button 
      className={`next-button ${className} ${disabled ? 'disabled' : ''}`}
      onClick={handleClick}
      disabled={disabled}
    >
      <span>{text}</span>
      <FontAwesomeIcon icon={faArrowRight} />
    </button>
  );
};

export default NextButton;
